/**
 * Utilities for handling resume sections, such as auto-detecting populated sections.
 */

/**
 * Auto-detects which sections have data based on formData content.
 * This is used to automatically expand section cards that contain data after an import or page load.
 *
 * @param {object} formData - The complete form data object.
 * @param {Array} allSections - An array of all available section configurations.
 * @returns {Array} An array of section objects (from allSections) that have data, with `expanded: true`.
 */
export const detectPopulatedSections = (formData, allSections) => {
  if (!formData || !allSections || !Array.isArray(allSections)) {
    console.warn("detectPopulatedSections: Invalid input. formData and allSections are required.", { formData, allSections });
    return [];
  }

  const autoDetectedSections = [];

  allSections.forEach(section => {
    if (!section || !section.sectionKey) return; // Skip invalid section configs

    const data = formData[section.sectionKey];
    let hasData = false;

    if (section.isArray) {
      // For array sections (like workExperiences, educations, etc.)
      hasData = Array.isArray(data) && data.length > 0;
    } else if (section.sectionKey === 'personalInfo') {
      // For personalInfo, check if any field has meaningful content
      if (data && typeof data === 'object') {
        hasData = Object.values(data).some(value =>
          value !== null && value !== undefined && String(value).trim() !== ''
        );
      }
    } else {
      // For simple string fields (like professionalSummary)
      hasData = data !== null && data !== undefined && String(data).trim() !== '';
    }

    if (hasData) {
      // Create a section object with expanded state for auto-opening cards
      autoDetectedSections.push({
        ...section,
        expanded: true // Ensure the card opens automatically
      });
    }
  });

  console.log("detectPopulatedSections: Auto-detected sections with data:", autoDetectedSections.map(s => s.name));
  return autoDetectedSections;
}; 